export * from './term';
export * from './term-constant';
export * from './term-function';
export * from './term-fully-inpatient-case-operating-number';
export * from './virtual-clinic-operating-number';
export * from './term-type';
export * from './term-factory';
